angular.module('inspinia').directive('baseList', () => {
  return {
    restrict: 'E',
    scope: {},
    templateUrl: `/manage/src/view/directive/base_list.html?${new Date().getTime()}`,
    transclude: true,
  };
});
angular.module('inspinia').directive('baseListItem', () => {
  return {
    restrict: 'E',
    scope: {},
    templateUrl: `/manage/src/view/directive/base_list_item.html?${new Date().getTime()}`,
    transclude: true,
    replace: true,
    require: '^baseList',
  };
});
